import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useTranslation } from "react-i18next";
// Generic yes/no confirmation dialog, styled to match ContractAffectedConfirmationDialog's
// idiom (same header/action-button treatment) since no reusable plain confirm dialog
// existed in the app before this.
const ConfirmDialog = ({ open, title, message, onClose, onConfirm, loading = false, }) => {
    const { t: translate } = useTranslation();
    return (_jsxs(Dialog, { open: open, onClose: !loading ? onClose : undefined, maxWidth: "xs", fullWidth: true, "aria-labelledby": "confirm-dialog-title", sx: {
            "& .MuiDialog-paper": {
                borderRadius: "8px",
            },
        }, children: [_jsx(DialogTitle, { id: "confirm-dialog-title", children: _jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 1.5 }, children: [_jsx(WarningAmberIcon, { sx: { fontSize: 32, color: "var(--n-primary, #130922)" } }), _jsx(Typography, { variant: "h6", sx: {
                                color: "var(--n-primary, #130922)",
                                fontWeight: 600,
                                fontSize: "18px",
                                lineHeight: "150%",
                            }, children: title })] }) }), _jsx(DialogContent, { children: _jsx(Typography, { sx: { fontSize: "14px", color: "var(--Neutral-700, #495057)" }, children: message }) }), _jsx(DialogActions, { children: _jsxs(Box, { sx: {
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        gap: 2,
                        width: "100%",
                        justifyContent: "flex-end",
                    }, children: [_jsx(Button, { variant: "outlined", color: "primary", onClick: onClose, disabled: loading, sx: {
                                display: "flex",
                                padding: "var(--1, 8px) var(--2, 16px)",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "var(--1, 8px)",
                                borderRadius: "var(--1, 8px)",
                                border: "var(--none, 1px) solid var(--n-primary, #130922)",
                            }, children: _jsx(Typography, { sx: {
                                    color: "var(--n-primary, #130922)",
                                    fontFeatureSettings: "'clig' off, 'liga' off",
                                    fontSize: "16px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "150%",
                                    letterSpacing: "1px",
                                }, children: translate("Cancel") }) }), _jsx(Button, { variant: "contained", color: "primary", onClick: onConfirm, disabled: loading, autoFocus: true, sx: {
                                display: "flex",
                                padding: "var(--1, 8px) var(--2, 16px)",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "var(--1, 8px)",
                                borderRadius: "var(--1, 8px)",
                                border: "var(--n-primary, #130922)",
                            }, children: _jsx(Typography, { sx: {
                                    color: "var(--Neutral-White, #FFF)",
                                    fontFeatureSettings: "'clig' off, 'liga' off",
                                    fontSize: "16px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "150%",
                                    letterSpacing: "1px",
                                }, children: loading ? translate("Processing...") : translate("Confirm") }) })] }) })] }));
};
export default ConfirmDialog;
